export const getBookingStatusAndStyles = (status) => {
    const statusMap = {
        PENDING: { label: "AWAITING_PAYMENT", buttonColor: "bg-yellow-500", textColor: "text-dark" },
        PENDING_APPROVAL: { label: "NEW", buttonColor: "bg-blue-500", textColor: "text-white" },
        DECLINED: { label: "DECLINED", buttonColor: "bg-red-500", textColor: "text-white" },
        CONFIRMED: { label: "BOOKED", buttonColor: "bg-[#8ec639]", textColor: "text-white" },
        UNDER_REVIEW: { label: "UNDER_REVIEW", buttonColor: "bg-orange-500", textColor: "text-white" },
        COMPLETED: { label: "COMPLETED", buttonColor: "bg-gray-500", textColor: "text-white" },
        CANCELLED: { label: "CANCELLED", buttonColor: "bg-red-600", textColor: "text-white" }, // Red for Cancelled
    };

    return statusMap[status] || { label: "UNKNOWN", buttonColor: "bg-gray-300", textColor: "text-white" };
};
